import { inject, provideAppInitializer } from '@angular/core';
import { AuthService } from './auth.service';

export const provideAuthInit = () =>
  provideAppInitializer(() => inject(AuthService).initialize());
